module.exports = "/img/806f417122d64a33f035e218353ad3af.svg";